<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="panelTitle" [description]="panelDescription" [icon]="panelIcon">

    <div class="col-12 mt-4 row">
      <div class="col-6">
        <app-dropdown-formularios dataSize="7" placeHolder="Empresa" [selectedValue]=""
          (selectedValueChange)="companySelectedChanged($event)" [required]="true" [disabled]="false"
          [dropdownType]="'Companies'" detailedData="true">
        </app-dropdown-formularios>
      </div>
    </div>



    <dx-data-grid #dataGrid id="gridContainer" [dataSource]="dataSource" [keyExpr]="'id'" [dataSource]="dataSource"
      (onToolbarPreparing)="onToolbarPreparing($event)" (onEditorPreparing)="onEditorPreparing($event)"
      (onOptionChanged)="onOptionChanged($event)" *ngIf="this.companySelected">


      <!-- Definición de las columnas -->
      <dxi-column dataField="title" caption="Nombre del documento"></dxi-column>
      <dxi-column dataField="customerName" caption="Empresa"> </dxi-column>
      <dxi-column dataField="containersNames" caption="Categoría" alignment="center"
        [allowFiltering]="true"></dxi-column>
      <dxi-column dataField="date" caption="Creación" alignment="center" [allowFiltering]="false"
        [allowHeaderFiltering]="false " dataType="date" format="dd/MM/yyyy" [sortOrder]="'desc'">
      </dxi-column>

      <!-- Templates -->
      <ng-container *ngIf="isCrud">
        <dxi-column dataField="Id" caption="Acciones" [allowFiltering]="false" [allowSorting]="false" alignment="center"
          cellTemplate="buttonCRUDTemplate"></dxi-column>
        <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
          <button rel="tooltip" type="button" class="btn btn-success btn-action" (click)="onEditDocument(data)">
            <i class="material-icons">edit</i>
          </button>
          <button rel="tooltip" type="button" class="btn btn-danger btn-action" (click)="onDeleteDoc(data)">
            <i class="material-icons">close</i>
          </button>
        </ng-container>
      </ng-container>

      <!-- Añadir nuevos -->
      <div *dxTemplate="let data of 'addNew'">
        <button class="btn btn-primary btn-sm btn-add" (click)="onClickAdd()">
          <i class="material-icons">add</i>
          <span class="d-none d-sm-inline-block">Nuevo</span>
        </button>
      </div>
    </dx-data-grid>

    <div *ngIf="loading" class="custom-loading-container">
      <div class="custom-loading-message">
        <div class="loader"></div>
        <span>Conectando con A3Doc Cloud</span>
      </div>
    </div>

  </app-generic-panel>

  <br>
</app-generic-container>